import type { AnyAction } from 'redux';
import * as CloudAdmin from '../../constants/cloud-admin';

export interface ToolsBarState {
  selectedToolButtonName: string;
}

const initialState: ToolsBarState = {
  selectedToolButtonName: CloudAdmin.TOOL_BUTTON_NAMES.USERS,
};

export function ToolsBarReducer(
  state: ToolsBarState = initialState,
  action: AnyAction,
): ToolsBarState {
  switch (action.type) {
    case CloudAdmin.TOOL_SELECTOR_ACTION_TYPES.SELECT_TOOL_BUTTON:
      return { ...state, selectedToolButtonName: action.selectedToolName };
    case CloudAdmin.TOOL_SELECTOR_ACTION_TYPES.CLEAR_TOOL_SELECTION:
      // Preserve existing runtime behavior exactly: original code spread an
      // `initialState` property rather than resetting to it. Cast keeps types
      // aligned to the slice shape without altering the emitted object.
      return { ...state, initialState } as ToolsBarState;
    default:
      return state;
  }
}
